import AbstractRestApi from './AbstractRestApi'
import SelectApiClientType from '@/api/SelectApiClientType'

class StoresApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/stores'
    }

    // store membership changes the restaurants' storeId shown in the select options
    getRelatedSelectApi() {
        return SelectApiClientType.RESTAURANT
    }
}

export default new StoresApiClient()
